import React from "react";

export const EditIcon = ({
  strokeWidth = 2,
  size = "15",
  color = "#1E22FF",
  cursor = "pointer"
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      style={{ cursor: cursor }}
    >
      <g clipPath="url(#clip0_4716_1463)">
        <path
          d="M6.25 2.77271H3.86364C2.909 2.77271 2.43168 2.77271 2.06706 2.95849C1.74633 3.12191 1.48557 3.38268 1.32215 3.70341C1.13636 4.06803 1.13636 4.54535 1.13636 5.49998V10.2727C1.13636 11.2273 1.13636 11.7047 1.32215 12.0693C1.48557 12.39 1.74633 12.6508 2.06706 12.8142C2.43168 13 2.909 13 3.86364 13H8.63636C9.591 13 10.0683 13 10.4329 12.8142C10.7537 12.6508 11.0144 12.39 11.1779 12.0693C11.3636 11.7047 11.3636 11.2273 11.3636 10.2727V7.88635M4.54544 9.59089H5.49688C5.77483 9.59089 5.9138 9.59089 6.04458 9.55949C6.16053 9.53166 6.27138 9.48574 6.37305 9.42344C6.48773 9.35316 6.586 9.25489 6.78253 9.05836L12.2159 3.62498C12.6866 3.15429 12.6866 2.39113 12.2159 1.92044C11.7452 1.44974 10.9821 1.44974 10.5114 1.92044L5.07797 7.35381C4.88144 7.55035 4.78317 7.64862 4.71289 7.76329C4.65059 7.86497 4.60467 7.97581 4.57684 8.09176C4.54544 8.22255 4.54544 8.36152 4.54544 8.63946V9.59089Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4716_1463">
          <rect width="13.6364" height="13.6364" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
